import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconCalendarEvent } from "@tabler/icons-react";

export const eventTypesDataUA: Item[] = [
  { key: "CS", value: "CS" },
  { key: "GAO", value: "GAO" },
  { key: "Large Rare Battle", value: "Large Rare Battle" },
  { key: "Rare Battle", value: "Rare Battle" },
  { key: "3on3", value: "3on3" },
  { key: "Standard Battle", value: "Standard Battle" },
  { key: "Regional", value: "Regional" },
  { key: "Regional Offline", value: "Regional Offline" },
  { key: "Regional Online", value: "Regional Online" },
  { key: "LGS", value: "Locals" },
];

const eventTypesData: Item[] = [
  { key: "CS", value: "CS" },
  { key: "GAO", value: "GAO" },
  { key: "Flagship", value: "Flagship" },
  { key: "3on3", value: "3on3" },
  { key: "Standard Battle", value: "Standard Battle" },
  { key: "Regional", value: "Regional" },
  { key: "Regional Offline", value: "Regional Offline" },
  { key: "Regional Online", value: "Regional Online" },
  { key: "LGS", value: "Locals" },
];

export function EventTypesFilterUA({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  return (
    <EventTypesFilter
      selected={selected}
      setSelected={setSelected}
      data={eventTypesDataUA}
    />
  );
}

export default function EventTypesFilter({
  selected,
  setSelected,
  data = undefined,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  data?: Item[] | undefined;
}) {
  let dataToUse = data || eventTypesData;

  return (
    <GenericFilter
      classNames="w-[120px] lg:w-[160px]"
      selected={selected}
      selectionMode="multiple"
      setSelected={setSelected}
      startContent={<IconCalendarEvent />}
      label="Event"
      data={dataToUse}
    />
  );
}
